import { getEnumValues } from './get-enum-values';
/**
 * Supported Customer Countries. Determines a customer's plans
 */
export enum CustomerCountry{
    CA = 'Canada',
    US = 'United States',
}
export const CustomerCountryValues = getEnumValues<CustomerCountry>(CustomerCountry);
export type CustomerCountryCode = keyof typeof CustomerCountry;